'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
function flatten(arr) {
    var depth = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    var result = [];
    var flooredDepth = Math.floor(depth);
    var recursive = function(arr, currentDepth) {
        for(var i = 0; i < arr.length; i++){
            var item = arr[i];
            if (Array.isArray(item) && currentDepth < flooredDepth) {
                recursive(item, currentDepth + 1);
            } else {
                result.push(item);
            }
        }
    };
    recursive(arr, 0);
    return result;
}
exports.flatten = flatten;
